import type { ComponentPropsWithoutRef } from 'react';
import type { ImageProps } from 'next/image';
import Image from 'next/image';

import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { PlatformLanguagesType } from '@/types/userType';

type IllustrationLanguagesType = PlatformLanguagesType;

export type IllustrationSrcType = {
    [TLang in IllustrationLanguagesType]: Pick<ImageProps, 'src'>;
};

type IllustrationProps = ComponentPropsWithoutRef<'div'> & {
    src: IllustrationSrcType;
    width?: number | `${number}`;
    height?: number | `${number}`;
    imgProps?: ImageProps;
};

export const Illustration = ({
    src,
    width = '400',
    height = '400',
    className = 'max-w-[400px]',
    imgProps,
    ...restProps
}: IllustrationProps) => {
    const { lang } = useTranslation() as { lang: IllustrationLanguagesType };
    return (
        <div className={clsx('relative w-full', className)} {...restProps}>
            <Image
                alt=""
                width={width}
                height={height}
                src={src[lang] ?? src['en']}
                placeholder={process.env.NODE_ENV === 'test' ? null : 'blur'}
                {...imgProps}
            />
        </div>
    );
};
